import React from 'react';
import { Navbar } from './Navbar';
import { Footer } from './Footer';

export const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-black text-white selection:bg-yellow-400 selection:text-black overflow-hidden">
      <Navbar />
      
      {/* Header Section */}
      <section className="relative pt-32 pb-20 overflow-hidden border-b-8 border-yellow-400">
        <div className="absolute inset-0 bg-halftone opacity-20 pointer-events-none"></div>
        <div className="container mx-auto px-6 relative z-10">
          <div className="inline-block bg-red-600 text-white px-4 py-1 transform -skew-x-12 mb-4 border border-white rotate-2 shadow-[4px_4px_0px_#eab308]">
            <span className="font-anton text-sm tracking-widest uppercase transform skew-x-12 inline-block">SECURITY PROTOCOL</span>
          </div>
          <h1 className="font-anton text-6xl md:text-8xl uppercase leading-none transform -rotate-2 text-shadow-hard">
            PRIVACY <span className="text-yellow-400">POLICY</span>
          </h1>
          <p className="font-marker text-xl md:text-2xl text-gray-400 mt-4 transform rotate-1">Cutthroat Dominoes Master // Version 2.0</p>
        </div>
      </section>

      <div className="container mx-auto px-6 py-16 relative z-10">
        <div className="grid md:grid-cols-12 gap-12">
          {/* Main Content Area */}
          <div className="md:col-span-8 space-y-12">
            
            {/* Scope */}
            <div className="bg-neutral-900 border-2 border-gray-700 p-8 transform rotate-1 border-l-8 border-l-yellow-400 relative">
              <div className="absolute -top-4 -right-4 bg-yellow-400 text-black font-anton px-3 py-1 text-xs transform -rotate-12">DATA SCOPE</div>
              <h2 className="font-anton text-3xl text-white mb-6 uppercase">Scope of this Policy</h2>
              <p className="font-sans text-gray-300 leading-relaxed text-lg">
                Cutthroat Dominoes Master is committed to protecting your privacy. This Privacy Policy explains how we handle data, including what we collect, how we use it, and your options for managing it.
              </p>
              <p className="font-sans text-gray-300 leading-relaxed text-lg mt-4">
                This applies to all our games, websites, and mobile applications, collectively referred to as the "Services".
              </p>
            </div>

            {/* Contact */}
            <div className="bg-black border-2 border-white p-8 transform -rotate-1 shadow-[8px_8px_0px_#ef4444]">
              <h2 className="font-anton text-3xl text-white mb-6 uppercase">Contact Information</h2>
              <p className="font-sans text-gray-300 leading-relaxed text-lg">
                If you have questions regarding personal data processing, please contact us at:
              </p>
              <div className="mt-6 bg-neutral-900 p-4 border border-gray-700 inline-block font-anton text-xl text-yellow-400 transform skew-x-6 hover:-translate-y-1 transition-transform cursor-pointer">
                ism220@gmail.com
              </div>
            </div>

            {/* Data Processing Table (Simplified/Styled) */}
            <div className="bg-neutral-900 border-2 border-gray-700 p-8 transform rotate-1">
              <h2 className="font-anton text-3xl text-white mb-8 uppercase">How We Use Your Data</h2>
              <div className="space-y-6">
                {[
                  { title: "Account Creation", desc: " nickname, email, device info, and third-party IDs to grant access.", basis: "Performance of Contract" },
                  { title: "Game Delivery", desc: "Progress, account data, and gameplay interactions to provide the service.", basis: "Performance of Contract" },
                  { title: "Communications", desc: "Support tickets and in-game chat logs to improve quality.", basis: "Legitimate Interests" },
                  { title: "Ads Personalization", desc: "Device ID, IP address, and advertising identifiers.", basis: "User Consent" }
                ].map((row, i) => (
                  <div key={i} className="border-b border-gray-800 pb-4 last:border-0">
                    <div className="font-anton text-yellow-400 text-xl mb-1">{row.title}</div>
                    <p className="text-gray-400 text-sm mb-2">{row.desc}</p>
                    <div className="inline-block bg-white text-black px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider">{row.basis}</div>
                  </div>
                ))}
              </div>
            </div>

            {/* Your Rights */}
            <div className="bg-white text-black p-8 border-4 border-black transform rotate-1 shadow-[10px_10px_0px_#eab308]">
              <h2 className="font-anton text-3xl mb-6 uppercase">Your Data Rights</h2>
              <div className="grid grid-cols-2 gap-4">
                {[
                  "Right of Access", "Right to Rectification", 
                  "Right to Erasure", "Right to Restriction",
                  "Data Portability", "Right to Object"
                ].map((right, i) => (
                  <div key={i} className="flex items-center gap-2 font-anton text-sm">
                    <div className="w-2 h-2 bg-red-600"></div> {right}
                  </div>
                ))}
              </div>
              <p className="mt-8 font-marker text-lg">Contact us to exercise any of these rights instantly.</p>
            </div>

          </div>

          {/* Sidebar / Quick Info */}
          <div className="md:col-span-4 space-y-8">
            <div className="bg-yellow-400 text-black p-6 transform -rotate-3 border-4 border-black">
              <h3 className="font-anton text-2xl mb-4 uppercase">Minors Protection</h3>
              <p className="font-sans text-sm font-semibold leading-relaxed">
                We do not knowingly collect data from children under 16 without parental consent. If we discover such data, we delete it immediately.
              </p>
            </div>

            <div className="bg-neutral-900 border-2 border-red-600 p-6 transform rotate-2">
              <h3 className="font-anton text-2xl mb-4 uppercase text-white">Security</h3>
              <p className="font-sans text-sm text-gray-400 leading-relaxed">
                We use industry-standard encryption and organizational controls to protect your data from unauthorized access.
              </p>
            </div>

            <div className="sticky top-24 bg-black border-2 border-white p-6 transform -rotate-1">
              <h3 className="font-anton text-xl mb-4 uppercase text-yellow-400">Policy Updates</h3>
              <p className="font-sans text-xs text-gray-500 leading-relaxed mb-4">
                We regularly update this policy. Significant changes will be communicated via the app or website.
              </p>
              <div className="text-[10px] font-mono text-gray-600 uppercase">Last Updated: Oct 2025</div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};